'use strict';

var app = angular.module('app', ['ngRoute', 'wj','pascalprecht.translate']);

app.config(['$routeProvider',function ($routeProvider) {
    $routeProvider.

    // store
    when('/store', { templateUrl: '/partials/store.htm' }).
    // product detail
    when('/product', { templateUrl: '/partials/product.htm'}).
    // shopping cart
    when('/cart', { templateUrl: '/partials/shoppingCart.htm' }).
    when('/complete', { templateUrl: '/partials/complete.htm' }).

    // default...
    when('/', { templateUrl: '/partials/store.htm' }).
    otherwise({ redirectTo: '/' });


}]);

app.config(['$translateProvider', function ($translateProvider) {

    $translateProvider.useStaticFilesLoader({
        prefix: '/translations/',
        suffix: '.json'
    });


    $translateProvider.preferredLanguage(phpVariables.locale);
    $translateProvider.fallbackLanguage("en");

}]);